import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ColorPickerService } from 'ngx-color-picker';
import { State } from '../../interfaces/tag';
import { ITranslate } from 'app/shared/constants';

@Component({
  selector: 'app-state-form',
  templateUrl: './state-form.component.html',
  styleUrls: ['./state-form.component.scss']
})
export class StateFormComponent implements OnChanges {
  @Output() addNewState = new EventEmitter<State>();
  @Output() removeSelectedState = new EventEmitter<number>();
  @Input() states: State[] = [];
  @Input() isComponentPage = false;
  stateForm = this.formBuilder.group({
    'state': ['', Validators.required],
    'value': ['', Validators.required],
    'isBlink': [false],
    'color': ['#fff']
  });

  color = '#fff';
  trans: ITranslate = { text: '' }; // for translation


  ngOnChanges(changes: SimpleChanges) {
    if(changes['isComponentPage'] && this.isComponentPage === false) {
      this.stateForm.disable();
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private readonly translate: TranslateService,
    private cpService: ColorPickerService) {
              // translation
              this.translate.onLangChange.subscribe(langChange => this.getTranslation());
              this.getTranslation();
    }
     /**
   * get translation
   */
     getTranslation(){
      this.translate.get('Component').subscribe(components => this.trans = components );
    }
  get isInvalidState() {
    const state = this.getControl('state').value;
    const value = this.getControl('value').value;

    return (this.states || []).some(s => s.state === state || s.value === value);
  }

  get colorValue() {
    return this.getControl('color').value;
  }

  getControl(prop: string): FormControl {
    return this.stateForm.get(prop) as FormControl;
  }

  addState() {
    const formData = this.stateForm.value;
    const state = {
      state: formData['state'],
      value: formData['value'],
      isBlink: formData['isBlink'] || false,
      color: this.color
    }

    this.addNewState.emit(state);
    this.stateForm.reset();
    this.color = '#fff';
  }

  removeState(index: number) {
    this.removeSelectedState.emit(index);
  }
}
